import { render } from "./RenewText.vue?vue&type=template&id=00967a09"
import script from "./RenewText.vue?vue&type=script&lang=js"
export * from "./RenewText.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__